const TextInput = ({
  label,
  name,
  register,
  errors,
  validationRules = {},
  type = "text",
  placeholder = "",
  helpText = null,
  autoComplete = false,
  className = "",
  inputClassName = "",
  ...rest
}) => (
  <div className={`mb-4 w-full ${className}`}>
    <label className="label label-text text" htmlFor={name}>
      {label}
    </label>
    <input
      id={name}
      className={`input w-full border border-gray-300 focus:outline-none focus:ring-1 focus:ring-primary ${inputClassName}`}
      type={type}
      autoComplete={autoComplete.toString()}
      placeholder={placeholder}
      {...register(name, validationRules)}
      {...rest}
    />
    {helpText && <p className="text-xs text-gray-500 mt-1">{helpText}</p>}
    {errors[name] && (
      <label className="label">
        <span className="text-error">{errors[name].message}</span>
      </label>
    )}
  </div>
);

export default TextInput;
